export class GetRestoreJobResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "job",
            "baseName": "job",
            "type": "RestoreJob",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetRestoreJobResponse.attributeTypeMap;
    }
    constructor() {
    }
}
